module.exports = __webpack_public_path__ + "img/Taman.dd245362.png";